import React, {PropTypes} from 'react';
import {FormattedNumber} from 'react-intl';

class Currency extends React.Component {

    static propTypes = {
        currency: PropTypes.string.isRequired,
        isBlock: PropTypes.bool,
        integer: PropTypes.bool,
        value: PropTypes.number.isRequired
    };

    render() {
        const {currency, value, isBlock, integer} = this.props;
        const amount = typeof value === 'number' ? value : parseFloat(value);

        if (currency === '') return <span>{value}</span>;
        const style = !!isBlock ? {display: 'block'} : {} ;
        const fractionDigits = !!integer ? 0 : 2;

        return (
            <span style={style}>
                 <FormattedNumber
                     style="decimal"
                     maximumFractionDigits={fractionDigits}
                     minimumFractionDigits={fractionDigits}
                     value={amount.toFixed(2)}/>
                <span>
                  &nbsp;{currency === 'CZK' ? 'Kč' : '€' }
                </span>
            </span>
        );
    }
}

export default Currency;



// WEBPACK FOOTER //
// ./src/browser/components/numbers/Currency.js